import { Component, OnDestroy, OnInit } from '@angular/core';
import { HighlightedMessageService } from './highlighted-message.service';

@Component({
  selector: 'app-highlighted-message',
  templateUrl: './highlighted-message.component.html',
  styleUrls: ['./highlighted-message.component.scss'],
})
export class HighlightedMessageComponent implements OnInit, OnDestroy {
  public message: string | null = null;
  public icon!: string;
  constructor(private msgService: HighlightedMessageService) {}
  ngOnInit(): void {
    this.msgService.message.subscribe((msg) => (this.message = msg));
    this.msgService.icon.subscribe((icn) => (this.icon = icn));
  }
  ngOnDestroy(): void {
    this.msgService.removeMessage();
  }
}
